import { Box, Button, Divider, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { DropdownModel, OutputTableInfo } from "../../data/interfaces/sharedmodels";
import { useCallback, useEffect, useState } from "react";
import jobService from "../../data/api/job.service";
import { OutputTableDetail } from "../../data/interfaces/tablegenmodels";
import { useAppSelector, useAppDispatch } from "../../stores/hooks";
import { OpenInFullSharp as OpenInFullSharpIcon, CloseFullscreenSharp as CloseFullscreenSharpIcon, ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import { updateOutputtableExpanded as magneticupdateOutputtableExpanded, updateBuildTableStep as updateMagneticBuildTableStep } from "../../stores/magneticslice";
import { updateOutputtableExpanded as itsoupdateOutputtableExpanded, updateBuildTableStep as updateItsoBuildTableStep } from "../../stores/itsoslice";
import OutputDataList from "./outputdatalist";


const OutputListHeader = ({ heading, parent,callback }: { heading: string | undefined, parent: string,callback:any }) => {    
    const tablexpanded = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.outputtableExpanded; }
        else { return state.itsoReducer.outputtableExpanded; }
    });
    const [showData,setShowData]=useState<boolean>(false);
    useEffect(()=>{
        callback(showData);
    },[showData])
    const dispatch = useAppDispatch();
    const handleExpand = () => {
        if (parent === 'magnetic') {
            dispatch(magneticupdateOutputtableExpanded(!tablexpanded));
        }
        else {
            dispatch(itsoupdateOutputtableExpanded(!tablexpanded));
        }
    }
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h6">{heading ?? 'Please select a table to see the data.'}</Typography>
            {heading == undefined ? '' : <Box component='div' sx={{ display: 'inline-flex' }}>
                {/* <IconButton sx={{ ml: 1 }} onClick={handleExpand}>
                    {!tablexpanded ? <OpenInFullSharpIcon />
                        : <CloseFullscreenSharpIcon />}
                </IconButton> */}
                <Button variant="outlined" onClick={()=>setShowData(!showData)}>{showData ? 'Show Details' : 'Show Data'}</Button>
            </Box>}
        </Box>
    )
}


export default function OutputTableDetails({ table, parent }: { table: OutputTableInfo | null, parent: string }) {

    const [outputTable, setOutputTable] = useState<OutputTableDetail | null>(null);
    const [showData, setShowData] = useState<boolean>(false);
    useEffect(() => {
        if (table&&!showData) {
            jobService.getOutputTableDetails(table.Id).then((response) => {
                if (response && response.data)
                    setOutputTable(response.data);
            })
        }
    }, [table,showData]);

    const showDatacallback= useCallback((show:boolean)=>{
        setShowData(show);
    },[])
    return (
        <Box component={Paper} sx={{ p: 2 }}>
            {outputTable ?

                <Box>
                    <OutputListHeader  heading={outputTable.Name + ' - ' + outputTable.Description} parent={parent}  callback={showDatacallback}/>
                     {showData&&table!=null?
                        <OutputDataList table={table} parent={parent}/>
                     :<Box>
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <Typography variant="body1">Table Scope : {outputTable.Scope}</Typography>
                            <Typography variant="body1">Table Format : {outputTable.Format}</Typography>
                            <Typography variant="body1">Data Source : {outputTable.Source}</Typography>
                        </Box>
                        <Divider />
                        <Box>
                            <Typography variant="h6">Linked Tables</Typography>

                            {outputTable ?
                                outputTable.LinkedTables.map((linkTable) => {
                                    return (
                                        <p key={linkTable.Id}>{linkTable.Description}</p>
                                    )
                                })

                                : null}
                        </Box>
                        <Divider />
                        <Box>
                            <Typography variant="h6">Fields</Typography>
                            <TableContainer>
                                <Table >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Name</TableCell>
                                            <TableCell>Type</TableCell>
                                            <TableCell>Size</TableCell>
                                            <TableCell>Pad Character</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {outputTable && outputTable.Fields ?
                                            outputTable.Fields.map((field) => {
                                                return (
                                                    <TableRow key={field.Name}>
                                                        <TableCell>{field.Name}</TableCell>
                                                        <TableCell>{field.Type}</TableCell>
                                                        <TableCell>{field.Size}</TableCell>
                                                        <TableCell>{field.PadCharacter}</TableCell>
                                                    </TableRow>
                                                )
                                            })

                                            : null}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>}
                </Box> : <Typography>Please select a table to see the details.</Typography>}

        </Box>
    )
}